<template>
  <div class="el-input-group el-input-group--append el-input-group--prepend">
    <div class="el-input-group__prepend">Is</div>
    <el-select
      v-close-on-zoom
      :value="scope"
      :disabled="readonly"
      placeholder="Select Scope"
      @input="value => selectScope(value)"
    >
      <el-option
        v-for="aScope in availableScopes"
        :key="aScope.id"
        :label="aScope.label"
        :value="aScope.id"
      />
    </el-select>
    <template>
      <el-select
        v-if="type === 'CUSTOM_ENUM_STATE'"
        v-close-on-zoom
        :value="state.check.id"
        placeholder="Custom Enum State"
        class="custom-state-select"
        :disabled="readonly"
        @input="customStateId => selectCustomEnumState(customStateId)"
      >
        <el-option
          v-for="customState in availableStates"
          :key="customState.id"
          :label="customState.label"
          :value="customState.id"
        />
      </el-select>
      <el-select
        v-else
        id="custom-state-select"
        v-close-on-zoom
        :value="state.check.id"
        placeholder="Custom state"
        class="custom-state-select"
        filterable
        :disabled="readonly"
        @input="customStateId => selectCustomState(customStateId)"
      >
        <el-option
          v-for="customState in availableStates"
          :key="customState.id"
          :label="customState.label"
          :value="customState.id"
        />
      </el-select>
    </template>
    <template>
      <el-select
        v-if="type === 'CUSTOM_ENUM_STATE'"
        v-close-on-zoom
        :value="state.check.value"
        :disabled="readonly"
        @input="value => updateCustomEnumStateValue(value)"
      >
        <el-option
          v-for="aValue in availableEnumValues"
          :key="aValue.id"
          :label="aValue.label"
          :value="aValue.id"
        />
      </el-select>
      <el-select
        v-else
        v-close-on-zoom
        :value="state.check.value"
        class="custom-state-value-select"
        :disabled="readonly"
        @input="value => updateCheckValue(value)"
      >
        <el-option label="True" :value="true" />
        <el-option label="False" :value="false" />
      </el-select>
    </template>
    <div class="el-input-group__append">?</div>
    <help-tooltip v-if="errors.length" type="error">
      <span v-for="error in errors" :key="error.message">{{ error.message }}<br></span>
    </help-tooltip>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import scopeMixins from '../utils/ScopeMixins';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'custom-state-check',
  components: {
    HelpTooltip,
  },
  mixins: [ scopeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        check: {
          id: null,
          value: this.type === 'CUSTOM_ENUM_STATE' ? null : true,
        },
        controlScope: null,
      },
      value: 0,
    };
  },
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.checkKey === this.ikey);
      return uniqBy(errors, 'message');
    },
    customStates() {
      return this.emitter.caseConf.caseLogicDescription.customStates || [];
    },
    customEnumStates() {
      return this.emitter.caseConf.caseLogicDescription.customEnumStates || [];
    },
    activeStates() {
      if (this.type === 'CUSTOM_ENUM_STATE') {
        return this.customEnumStates;
      } else {
        return this.customStates;
      }
    },
    availableScopes() {
      const allScopeInfos = this.getAvailableScopes(this.emitter.caseConf);
      return allScopeInfos.filter(info => this.activeStates.find(state => state.scope === info.id));
    },
    availableStates() {
      return this.getAvailableStates(this.activeStates, this.scope);
    },
    availableEnumValues() {
      return this.getAvailableEnumValues(this.customEnumStates, this.state.check.id);
    },
    scope() {
      if (this.state.check.id) {
        const state = this.activeStates.find(state => state.id === this.state.check.id);
        return state ? state.scope : null;
      }
      return this.state.controlScope;
    },
  },
  mounted() {
    this.state.check = this.getData(this.ikey) || this.state.check;
    if (!this.state.check.id) {
      // Default to first scope to save a click
      this.state.controlScope = this.availableScopes.length ? this.availableScopes[0].id : null;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    selectScope(scope) {
      this.state.controlScope = scope;
      this.state.check.id = null;
      this.state.check.value = null;
      this.update();
    },
    selectCustomState(customStateId) {
      this.state.check.id = customStateId;
      this.update();
    },
    selectCustomEnumState(customStateId) {
      this.state.check.id = customStateId;
      this.state.check.value = null;
      this.update();
    },
    updateCheckValue(value) {
      this.state.check.value = value;
      this.update();
    },
    updateCustomEnumStateValue(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.type,
        id: this.state.check.id,
        operator: 'EQUAL',
        value: this.state.check.value,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.custom-state-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 1200px;
}

.custom-state-select {
  width: auto;
}

.custom-state-value-select {
  width: 100px;
}
</style>
